// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__E5Cie","name":"ConsentHeader_name__SHyIf","birthday":"ConsentHeader_birthday__1jL5g","skeleton":"ConsentHeader_skeleton__1mduw"};